import {
    apiRequest,
    mertuaDetail,
    mertuaUpdate,
    masterRegion
} from "../../../../../../services/adapters/kepegawaian/mertuaService"

class UpdateRepository {

    fetchRegionCountry = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityDistrict = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchIdentityVillage= async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", mertuaDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", mertuaUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository